// src/features/media/components/VideosLayout.tsx

import { useEffect, useRef } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { SelectionProvider } from '@/shared/contexts/SelectionContext';
import { useVideoGridState } from '../stores/videoGridState';
import { markStart } from '@/shared/utils/perf';

/**
 * Layout route for /videos.
 * SelectionProvider wraps both list and detail routes so selection persists.
 * Grid/search/sort/scroll state persistence is handled by Zustand store.
 */
export function VideosLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const markBackNavStart = useVideoGridState((s) => s.markBackNavStart);
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const movedFromDetailToList =
      /^\/videos\/.+/.test(prevPath) &&
      (pathname === '/videos' || pathname === '/videos/');

    if (movedFromDetailToList) {
      markBackNavStart();
      markStart('videos.grid.backnav.firstRowsPaint');
    }

    prevPathRef.current = pathname;
  }, [pathname, markBackNavStart]);

  return (
    <SelectionProvider>
      <Outlet />
    </SelectionProvider>
  );
}
